import React, {Component} from 'react';
import {connect} from "react-redux";
import {Trans} from 'react-i18next';
import { withTranslation } from 'react-i18next';
import Icon from "../../../../../../components/icon";
import {API_ROOT} from "../../../../../../utils";
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";

class LabelCreationLimitPopup extends Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    closeHandler(){
        this.props.getSharingDetailsPopup([]);
    }

    render() {
        if(this.props.invited){
            return (
                <div className="p-4">
                    <h2><Icon name="times" className="text-danger"/> <span className="text-danger">{this.props.t("errorText")}</span></h2>
                    <p>{this.props.t("textDescriptionInvited")}</p>
                    <div className="text-right">
                        <Button className="btn-primary" onClick={this.closeHandler}>{this.props.t("okText")}</Button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="p-4">
                    <h2><Icon name="level-up" className="text-danger"/> <span className="text-danger">{this.props.t("textUpgradeTitle")}</span></h2>
                    <p><Trans i18nKey="textStatusDescriptionTeamPlan3" values={{Plan_name:"Basic or Lite"}}/></p>
                    <p><Trans i18nKey="textUpgradeContent2" values={{plan_name:"Basic and Lite"}}/></p>
                    <ul>
                        <li>{this.props.t("textUpgradeContent3")}.</li>
                        <li>{this.props.t("textUpgradeContent4")}</li>
                        <li>{this.props.t("textUpgradeContent5")}</li>
                        <li>{this.props.t("textBasicAndLite2")}</li>
                        <li>{this.props.t("textBasicAndLite3")}</li>
                    </ul>
                    <hr/>
                    <h3>{this.props.t("textUpgradeContent8")}</h3>
                    <p><Trans i18nKey="textUpgradeContent9" values={{plan_name:"Enterprise"}}/></p>
                    <div className="text-right">
                        <a role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/upgrade`} target="_blank" rel="noreferrer">{this.props.t("textUpgradeNow")}</a>
                    </div>
                </div>
            );
        }

    }
}

const mapDispatchToProps = dispatch => ({
    getSharingDetailsPopup: (array) => {
        dispatch(getSharingDetailsPopup(array))
    },
});

export default connect(null, mapDispatchToProps)(withTranslation()(LabelCreationLimitPopup));